import { useNavigate } from '@tanstack/react-router';
import { Button, Card } from '@nexora/design-system';

export function PosPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="pos-page">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-md mb-lg">
        <div>
          <h1 className="font-display-lg text-display-lg text-on-surface m-0">PDV &mdash; Ponto de Venda</h1>
          <p className="font-body-md text-body-md text-on-surface-variant mt-xs">Gerencie vendas no balc&atilde;o e sess&otilde;es de caixa.</p>
        </div>
      </div>

      <div className="pos-cards">
        <Card>
          <div className="pos-card-content">
            <div className="pos-card-icon">&#x1f4b0;</div>
            <h2>Nova venda</h2>
            <p>Iniciar uma venda r&aacute;pida no balc&atilde;o</p>
            <Button
              variant="primary"
              onClick={() => navigate({ to: '/pos/sale' })}
            >
              Ir para vendas
            </Button>
          </div>
        </Card>

        <Card>
          <div className="pos-card-content">
            <div className="pos-card-icon">&#x1f9fe;</div>
            <h2>Sess&atilde;o de caixa</h2>
            <p>Abrir ou fechar sess&atilde;o e ver hist&oacute;rico</p>
            <Button
              variant="secondary"
              onClick={() => navigate({ to: '/pos/session' })}
            >
              Gerenciar sess&atilde;o
            </Button>
          </div>
        </Card>
      </div>

      <style>{`
        .pos-page {
          padding: 2rem;
        }
        .subtitle {
          color: #43474e;
          font-size: 0.875rem;
          margin-bottom: 2rem;
        }
        .pos-cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
          max-width: 700px;
        }
        .pos-card-content {
          padding: 1.5rem;
          text-align: center;
        }
        .pos-card-icon {
          font-size: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .pos-card-content h2 {
          font-size: 1.125rem;
          margin-bottom: 0.5rem;
        }
        .pos-card-content p {
          color: #43474e;
          font-size: 0.875rem;
          margin-bottom: 1.25rem;
        }
      `}</style>
    </div>
  );
}
